import Info from './Info';

export default Info;


// WEBPACK FOOTER //
// ./src/components/Info/index.js